import React, { useState, useEffect, useRef } from 'react';


const FlexView = ({ isFlexHeightFixed, isFlexItemFixed, appState }) => {

  const [flexContainerHeight, setFlexContainerHeight] = useState('');

  const [calculatedWidth, setCalculatedWidth] = useState('');
  const [flexContainerWidth, setFlexContainerWidth] = useState('');

  let flexViewHeightRef = useRef(null);
  let flexViewWidthRef = useRef(null);

  useEffect(() => {

    setFlexContainerHeight(flexViewHeightRef.current.offsetHeight - 40);
    setCalculatedWidth(flexViewWidthRef.current.offsetWidth);

  }, []);


  const handleFlexViewWidth = (e) => {
    setFlexContainerWidth(calculatedWidth * e.target.value / 100);
  };


  return (
    <div className="flex-view" ref={flexViewHeightRef}>

      <div className="flex-container"
        ref={flexViewWidthRef}
        style={{
          height: isFlexHeightFixed && flexContainerHeight,
          width: flexContainerWidth,
          ...appState.parentProps
        }}
      >

        {
          appState.flexItemProps.map((i, j) =>
            <div
              key={j} 
              className="flex-item-box"
              style={{
                ...appState.flexItemProps[j],
                height: isFlexItemFixed && '4rem',
                width: isFlexItemFixed && '4rem'
              }}
            >
              {j + 1}
            </div>
          )
        }


      </div>

      <input
        type="range" min="1" max="100" defaultValue={100}
        className="slider py-2" id="myRange"
        onChange={e => handleFlexViewWidth(e)}
      />

    </div>
  );
}

export default FlexView;